import type {
  GetDocumentsQuery,
  GetDocumentsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_DOCUMENTS: TypedDocumentNode<
  GetDocumentsQuery,
  GetDocumentsQueryVariables
> = gql`
  query GetDocuments($search: String) {
    documents(search: $search) {
      id
      path
      userId
      context
      value
      format
      formatValidation
      createdAt
      updatedAt
      documentHistory {
        id
        value
        documentId
        createdAt
      }
    }
  }
`;
